// Propagación del Encounter abierto a los formularios de las pestañas de
// Enfermería (2026-09-13). El resto de la ficha ya lo hacía: NotasTab pasa
// `encounter` a SelectorFormularios, que lo cuelga como `?encounter=` de cada
// link, y FormularioDiscretoPage/MotorFormularioPage lo leen de ahí. Las
// pestañas de Enfermería (Kardex/Intervenciones/Nota de turno) son links de
// `LinkTabs`, que armaba `to={baseUrl}/{value}` SIN query — así que todo lo
// que registraba una enfermera quedaba sin `Encounter` (bug confirmado por el
// revisor funcional, igual que el botón "Registrar 020" de SignosVitalesTab).
//
// Lógica pura, sin React ni MedplumClient — se prueba en enlaceEncounter.test.ts.

/** Nombre del query param que ya usan FormularioDiscretoPage, MotorFormularioPage y Formulario001Page. */
export const PARAM_ENCOUNTER = 'encounter';

/**
 * `?encounter=Encounter%2F123` para colgarle a un link de pestaña, o `''` si
 * no hay Encounter abierto (una enfermera NO abre consultas: sin estancia ni
 * consulta en curso el registro queda sin vínculo, igual que hasta hoy).
 */
export function busquedaDeEncounter(encounterRef?: string | null): string {
  const ref = encounterRef?.trim();
  return ref ? `?${PARAM_ENCOUNTER}=${encodeURIComponent(ref)}` : '';
}

/**
 * Agrega `?encounter=` a un enlace ya armado, respetando un query string
 * previo. Devuelve el enlace intacto si no hay Encounter o si el enlace ya
 * trae su propio `encounter` (no lo pisa: el de la URL es más específico).
 */
export function enlaceConEncounter(href: string, encounterRef?: string | null): string {
  const ref = encounterRef?.trim();
  if (!ref) return href;
  const [base, query = ''] = href.split('?');
  const params = new URLSearchParams(query);
  if (params.has(PARAM_ENCOUNTER)) return href;
  params.set(PARAM_ENCOUNTER, ref);
  return `${base}?${params.toString()}`;
}
